import * as React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import { blue, neutral, pallette } from '../theme/colors';
import { baseButtonStyles } from './primary-button';
import clsx from 'clsx';

export interface SecondaryButtonProps extends ButtonProps {
  /** Text of the button */
  text: string;
  /** Title of the button, shown on hover */
  title?: string;
  /** Set to `true` to disable the button */
  deactive?: boolean;
  /** extra styles to be included inline */
  styles?: any;
  /** `onClick` handler */
  handleClick: (event?: Event) => void;
  /** `true` by default, set to false to **not** use `event.preventDefault()` */
  preventDefault?: boolean;
  /** Optional, set to component other than `<button>` */
  component?: any;
}

const useStyles = makeStyles({
  root: {
    backgroundColor: blue[500],
    color: pallette.textLight,
    '&:hover': {
      backgroundColor: blue[600]
    },
    '&:active': {
      backgroundColor: blue[300],
      color: neutral[700]
    },
    '&:focus': {
      backgroundColor: blue[300]
    }
  }
});

/**
 * Button with lower priority than Primary Buttons
 */
const SecondaryButton = ({
  text,
  title,
  deactive,
  styles: extraStyles,
  handleClick,
  component,
  preventDefault,
  ...props
}: SecondaryButtonProps) => {
  const base = baseButtonStyles();
  const classes = useStyles();
  return (
    <Button
      title={title}
      className={clsx(base.root, classes.root)}
      onClick={(event: Event) => {
        if (preventDefault === undefined || preventDefault) {
          event.preventDefault();
        }
        handleClick();
      }}
      variant="contained"
      color="primary"
      disabled={deactive}
      style={extraStyles}
      component={component}
      {...props}
    >
      {text}
    </Button>
  );
};

export default SecondaryButton;
